/* eslint-disable multiline-ternary */
import PropTypes from 'prop-types'
import React, { useCallback } from 'react'
import FacebookLogin from 'react-facebook-login'
import GoogleLogin from 'react-google-login'
import { useHistory } from 'react-router-dom'
import { useToasts } from 'react-toast-notifications'

import authApi from '_api/auth'
import { FACEBOOK, GOOGLE, UNKNOWN } from '_utils/constant'
import { parseJwt } from '_utils/function'
import { setSocialToken, setUserInfo, setUserToken } from '_utils/localData'

const SocialButton = ({
  social = FACEBOOK,
  isLogin = true,
  setIsShowFormConnect,
  renderButton,
}) => {
  const history = useHistory()
  const { addToast } = useToasts()

  const response = useCallback(
    async (resp) => {
      let userInfo = null
      const token = resp?.accessToken
      if (social === FACEBOOK) {
        if (resp.status !== UNKNOWN) {
          userInfo = {
            name: resp.name,
            email: resp.email,
            imageUrl: resp.picture.data.url,
            id: resp.userID,
          }
        } else {
          return
        }
      } else if (social === GOOGLE) {
        const { name, email, imageUrl, googleId: id } = resp.profileObj
        userInfo = {
          name,
          email,
          imageUrl,
          id,
        }
      }

      if (isLogin) {
        try {
          const _res = await authApi.login3rdParty({ type: social, accessToken: token })
          setUserToken(_res.msgResp.token)
          setUserInfo(parseJwt(_res.msgResp.token))
          history.push('/welcome')
        } catch ({ msgResp }) {
          addToast(msgResp, { appearance: 'error', autoDismiss: true })
        }
      } else {
        setIsShowFormConnect(true)
        userInfo.social = social
        setUserInfo(userInfo)
        setSocialToken(token)
      }
    },
    [social, isLogin, history, addToast, setIsShowFormConnect]
  )

  const renderGoogleButton = useCallback(
    (renderProps) => {
      if (renderButton) {
        return renderButton(renderProps)
      }
      return (
        <button className='btn btn--gray btn--bold' onClick={renderProps.onClick}>
          <i className='icon-google'></i>Google
        </button>
      )
    },
    [renderButton]
  )

  return (
    <>
      {social === FACEBOOK ? (
        <FacebookLogin
          appId={process.env.REACT_APP_FACEBOOK_APP_ID}
          fields='name,email,picture'
          callback={response}
          cssClass={isLogin ? 'btn btn--gray btn--bold' : 'btn btn--graylight btn--bold'}
          icon={<i className='icon-fb'></i>}
          textButton='Facebook'
          isMobile={false}
        />
      ) : (
        <GoogleLogin
          icon={false}
          clientId={process.env.REACT_APP_GOOGLE_APP_ID}
          onSuccess={response}
          render={renderGoogleButton}
        />
      )}
    </>
  )
}

export default SocialButton

SocialButton.propTypes = {
  setIsAuthError: PropTypes.func,
  setIsShowFormConnect: PropTypes.func,
  social: PropTypes.string,
  isLogin: PropTypes.bool,
  renderButton: PropTypes.func,
}
